/* eslint-disable no-mixed-operators */
import { showUserDisplayName } from '../../../../lib/userUtils';
import { convertToDateFirst } from '../../../../lib/utils';

const getTestCaseFieldName = (eventEntity) => {
  if (eventEntity === 'testcase-assignedTo') return 'Assigned To';
  if (eventEntity === 'testcase-environment') return 'Environment';
  if (eventEntity.includes('assignedTo')) return eventEntity.replace('assignedTo', 'Assigned To');
  if (eventEntity.includes('environment')) return eventEntity.replace('environment', 'Environment');
  return eventEntity;
};

const getTestCycleFieldName = (eventEntity) => {
  if (eventEntity === 'startDate') return 'Start Date';
  if (eventEntity === 'endDate') return 'End Date';
  if (eventEntity === 'completionDate') return 'Completion Date';
  if (eventEntity === 'releaseVersion') return 'Release Version';
  return <span className="text-capitalize">{eventEntity}</span>;
};

export const getUpdateInfo = (item, users, environments, statuses, releases, jobs) => {
  const { event_type, event_entity: eventEntity, old_value: oldValueRaw, new_value: newValueRaw } = item;
  let oldValue = oldValueRaw || '';
  let newValue = newValueRaw || '';
  
  if (oldValue === newValue) return null;

  if (['REMOVED_TEST_CASE', 'ADDED_TEST_CASE', 'REMOVED_ATTACHMENT_CYCLE', 'CREATED_ITERATION', 'REMOVED_EXECUTION', 'EXECUTION_STATUS_UPDATE'].includes(event_type)) {
    return <p>{newValue}</p>;
  }

  if (event_type === 'ADDED_ATTACHMENT_CYCLE') {
    return (
      <p>{newValue.split('@')[1]}</p>
    );
  }

  if (event_type === 'UPDATED_TEST_CASE') {
    if (eventEntity.includes('assignedTo')) {
      oldValue = showUserDisplayName(oldValue, users);
      newValue = showUserDisplayName(newValue, users);
    } else if (eventEntity.includes('environment')) {
      oldValue = environments?.find((env) => env.id === oldValue)?.name || '';
      newValue = environments?.find((env) => env.id === newValue)?.name || '';
    }

    return (
      <tr>
        <td>{getTestCaseFieldName(eventEntity)}</td>
        <td>{oldValue}</td>
        <td>{newValue}</td>
      </tr>
    );
  }

  if (event_type === 'UPDATED_TEST_CYCLE') {
    if (eventEntity === 'status') {
      oldValue = statuses?.find((status) => status.id === oldValue)?.name || '';
      newValue = statuses?.find((status) => status.id === newValue)?.name || '';
    } else if (['startDate', 'endDate', 'completionDate'].includes(eventEntity)) {
      oldValue = oldValue ? convertToDateFirst(oldValue) : '';
      newValue = newValue ? convertToDateFirst(newValue) : '';
    } else if (eventEntity === 'owner') {
      oldValue = oldValue ? showUserDisplayName(oldValue, users) : '';
      newValue = newValue ? showUserDisplayName(newValue, users): '';
    } else if (eventEntity.includes('releaseVersion')) {
      oldValue = releases?.find((release) => release.id === oldValue)?.name || '';
      newValue = releases?.find((release) => release.id === newValue)?.name || '';
    } else if (eventEntity === 'job') {
      oldValue = jobs?.find((job) => job.id === oldValue)?.name || '';
      newValue = jobs?.find((job) => job.id === newValue)?.name || '';
    }

    return (
      <tr>
        <td>{getTestCycleFieldName(eventEntity)}</td>
        <td>{oldValue}</td>
        <td>{newValue}</td>
      </tr>
    );
  }

  return null;
};

export const getItemText = (item) => {
  switch (item.event_type) {
    case 'REMOVED_TEST_CASE':
      return 'removed test case(s).';
    case 'ADDED_TEST_CASE':
      return 'added new test case(s).';
    case 'CREATED_TEST_CYCLE':
      return 'created this test cycle.';
    case 'UPDATED_TEST_CASE':
      return 'updated test case(s) details.';
    case 'UPDATED_TEST_CYCLE':
      return 'updated test cycle details.';
    case 'MARKED_COMPLETED':
      return 'marked the test cycle completed.';
    case 'ADDED_ATTACHMENT_CYCLE':
      return 'added some attachment(s).';
    case 'REMOVED_ATTACHMENT_CYCLE':
      return `removed some attachment(s).`;
    case 'CREATED_ITERATION':
        return 'created new iteration.';
    case 'REMOVED_EXECUTION':
        return 'removed test case execution(s)';
    case 'EXECUTION_STATUS_UPDATE':
        return 'started test case execution(s)';
    default:
      return '';
  }
};
